import React, {useState} from 'react'
import ReactDOM, {unmountComponentAtNode} from 'react-dom'
import {DataObjectId} from 'yougile-model'
import {DateInput} from '@components/common/date-picker/date-input'
import {useBoolean} from '@containers/hooks'
import {UIElement} from '../ui-element'

export interface DateInputProps {
  onChange: (value: Date) => void
  initialValue?: Date

  disablePastDate?: boolean
  showTimeInput?: boolean
  large?: boolean
}

export class DateInputWrapper extends UIElement {
  private props: DateInputProps
  private previous: HTMLElement

  constructor(companyId: DataObjectId, props: DateInputProps) {
    super(companyId, undefined, undefined)
    this.props = props
  }

  public override render(el: HTMLElement): void {
    el.innerHTML = ''
    el.className = 'ui-date-input'

    this.clean()

    renderElement(el, this.props)
    super.render(el)

    this.previous = el
  }

  public clean() {
    // to avoid memory leaks
    this.previous && unmountComponentAtNode(this.previous)
  }
}

const DateInputBase = (props: DateInputProps) => {
  const {disablePastDate, showTimeInput, large = false} = props
  const [value, onChange] = useState<Date>(props.initialValue ?? new Date())
  const valid = useBoolean(true)

  const localOnChange = (value: Date) => {
    props?.onChange(value)
    onChange(value)
  }

  return (
    <DateInput
      initialDate={value}
      onChoose={localOnChange}
      valid={valid}
      disablePastDates={disablePastDate}
      showTimeInput={showTimeInput}
      large={large}
    />
  )
}

export const renderElement = (element: HTMLElement, props: DateInputProps) => {
  ReactDOM.render(<DateInputBase {...props} />, element)
}
